const benefits = [
  {
    icon: "ri-flashlight-line",
    title: "Schnelle Produktsuche",
    desc: "Finde Produkte in Sekunden statt Minuten. Das OOPBuy Spreadsheet zeigt alle relevanten Artikel auf einen Blick.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Bessere Übersicht",
    desc: "Strukturierte Tabellen und Kategorien sorgen für eine klare Darstellung aller verfügbaren Produkte.",
  },
  {
    icon: "ri-scales-line",
    title: "Einfacher Vergleich",
    desc: "Vergleiche Preise, Qualität und Bewertungen direkt nebeneinander im OOPBuy Spreadsheet.",
  },
  {
    icon: "ri-refresh-line",
    title: "Aktuelle Produktlisten",
    desc: "Regelmäßig aktualisierte Spreadsheet Listen mit den neuesten Produkten und aktuellen Preisen.",
  },
  {
    icon: "ri-time-line",
    title: "Weniger Recherchezeit",
    desc: "Spare wertvolle Zeit bei der Produktrecherche durch vorsortierte und geprüfte Informationen.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Mehr Sicherheit",
    desc: "Geprüfte Produkte und transparente Informationen geben dir Sicherheit bei jeder Kaufentscheidung.",
  },
];

export default function BenefitsSection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Vorteile
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            Warum nutzen immer mehr deutsche Käufer OOPBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Immer mehr Nutzer aus Deutschland, Österreich und der Schweiz setzen auf OOPBuy Spreadsheet für ihre Produktrecherche
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-4">
                <i className={`${benefit.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-foreground-900 text-base md:text-lg mb-2">
                {benefit.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}